import { useEffect, useState, useContext } from "react";
import styles from "./styles.module.css";
import { db, functions } from "../../firebase";
import { LoaderDisbatch } from "../../contexts/loader";
const updateAppDomain = functions.httpsCallable("updateAppDomain");

export default function Domain({ plan, domain, appId }) {
  const [_domain, setDomain] = useState("");
  const [error, setError] = useState("");
  const setLoader = useContext(LoaderDisbatch);
  useEffect(() => {
    if (domain) {
      setDomain(domain);
    } else {
      setDomain("");
    }
  }, [domain]);

  const handleSaveDomain = async () => {
    setLoader(true);
    updateAppDomain({ appId, domain: _domain })
      .then(() => {
        setError("");
        setLoader(false);
      })
      .catch((err) => {
        setError(
          "We couldn't find the right DNS records attatched to this domain. They can take several hours to propigate so please try again later. If you keep getting this error after 24 hours please contact support."
        );
        setLoader(false);
      });
  };

  const handleRemoveDomain = async () => {
    setLoader(true);
    updateAppDomain({ appId, domain: null })
      .then(() => {
        setError("");
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };
  if (plan === "free") {
    return (
      <div className={styles.paper}>
        <div className={styles.subtitle}>App Domain</div>
        <div className={styles.disabledText}>
          Custom domains are only available on paid plans
        </div>
      </div>
    );
  }
  return (
    <div className={styles.paper}>
      <div>
        <div className={styles.subtitle}>App Domain</div>
        <div className={styles.inputTitle}>Enter domain</div>
        <div style={{ display: "flex" }}>
          <input
            className={"input"}
            style={{ flexGrow: 1 }}
            value={_domain}
            disabled={!!domain}
            onChange={(e) => setDomain(e.target.value)}
          />
          {domain && (
            <button onClick={handleRemoveDomain} className={styles.remove}>
              Remove Domain
            </button>
          )}
        </div>
        {error && <div className={styles.errorText}>{error}</div>}
        {_domain !== domain && (
          <div>
            <button onClick={handleSaveDomain} className={styles.cardButton}>
              SAVE
            </button>
          </div>
        )}
        <div className={styles.helpText}>
          For instructions on how to connect your domain,{" "}
          <a
            href="https://www.notion.so/brevity/Connecting-your-domain-to-Brevity-0f5de454dc494a1885e654df01212548"
            className={styles.clickHere}
          >
            click here
          </a>
        </div>
      </div>
    </div>
  );
}
